import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@material-ui/core/Typography';
import  {Component} from 'react';
import monday from './monday.json';
import tuesday from './tuesday.json';
import wednesday from './wednesday.json';
import thursday from './thursday.json';
import friday from './friday.json';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Link from '@material-ui/core/Link';

import map from './mapKTH.pdf';

const classes=  {
    h1 : {
        margin:'left',
        align:'left',
        justify:'left',
        color: '#009688',
        marginTop:30,
        paddingTop:5,
        width:'100%',
        marginBottom:20,
        
        borderTop: 'solid 0.02em',
        },
    h2 : {
    margin:'auto',
    align:'left',
    justify:'left',
    color: '#009688',
    paddingBottom:30,
    borderBottom: 'solid 0.04em',
    width:'100%',
    marginBottom:60,
    fontStyle:'italic'
    },
    h3: {
      margin:'auto',
    },
    p: {
       color: '#4A4A4A'
    }
}


const GenListItem=(item) =>{ 
  return(
  <ExpansionPanel  key={item.title} className={classes.root}>
    <ExpansionPanelSummary
      expandIcon={<ExpandMoreIcon />}
      style={{ backgroundColor : '#C1E5DD', marginTop:'20'}}
    >
        <Typography> 
           <span style={{ fontStyle:'', fontSize : '16px', color: '#333333'   }}> {item.time} <br/></span> 
           <span style={{ fontStyle:'bold', fontSize : '16px', color: '#333333'   }}> {item.speaker} <br/></span> 
           <span style={{ fontStyle:'italic', fontSize : '16px', color: '#333333'   }}> {item.title} <br/></span> 
        </Typography>
    </ExpansionPanelSummary>
  
    <ExpansionPanelDetails style={{backgroundColor :'#E6EBE9'}}>
      <Typography style ={{marginLeft : '6%', width : '88%',  fontSize : '14px', color: '#333333'}}>
        <br/>
        Abstract:   <br/><br/> {item.abstract} 
        <br/>     
        <br/>   
      </Typography>
    </ExpansionPanelDetails>
  </ExpansionPanel>
);
  ;}

function createData(name, mon, tue, wed, thu,fri) {
    return { name, mon, tue, wed, thu,fri };
  }
  
  const rows = [
    createData('9:15--9:30','Opening','','','',''),
    createData('9:30--10:20','Diaconis','Berman','Spohn','Bourgade','9:30--10:20 Quastel'),
    createData('10:20--10:45','','' ,'','','10:20--11:10 Seppäläinen'),
    createData('10:45--11:35','Baik','Gorin','van Moerbeke','Erdös', '11:10--11:30 Coffee'),
    createData('11:35--12:25','Virag','Aggarwal','Kuijlaars' ,'Ben Arous','11:30--12:20 Ferrari'),
    createData('12:25--2:30','','' ,'','','12:20-- 13:10 O Connell',),
    createData('2:30--3:20','Zeitouni', 'Borodin', '', 'Fyodorov', ''),
    createData('3:20--4:10','Serfaty', 'Keating', '', 'Kupiainen', ''),
    createData('4:10--4:30','','' ,'','','',''),
    createData('4:30--5:20','','Okounkov (Zoom talk) ' ,'','','',''),
    createData('','',"5:30 Reception + posters","6:00 Dinner",'','')
  ];

  
export class Program extends Component {
  constructor(props){ 
    super(props);
    this.state={
      list:monday.monday,
    list2:tuesday.tuesday,
    list3:wednesday.wednesday,
    list4:thursday.thursday,
    list5:friday.friday};}
      
    render() {
        return ( 
            <div align="left" style={{margin:'7%'}}>
                <Typography variant="h3" style={classes.h1}>
                   Program and Abstracts
                </Typography>     
                <br></br>
                <Typography style={classes.p} >
                  <li>All talks (except one) will be in room K1 on KTH campus. Click <Link href="https://www.google.com/maps/place/59.350127,18.074595/&zoom=17"> here </Link> for directions. A general map of the campus can be found <Link href={map} download>here</Link>
                  </li>
                </Typography>
                <br></br>
                <Typography style={classes.p} >
                   <li>The talk by Andrei Okounkov on Tuesday afternoon will be an online zoom talk broadcasted in the lecture room. 
                  <br></br> Meeting ID: 687 2583 3217 <br></br> Password: 108445
                  </li>
                </Typography>
                <br></br>
                
                
                <Typography style={classes.p} >
                  <li>
                   Monday  June 6 is a national holiday and many lunch places will be closed. Therefore we have made special arrangements for Monday (and only then). Lunch will be served in the lunch room of the mathematics department. For the other days we have listed a few options under "Practical Info".
                   </li>
                </Typography>           
                
               
                <br></br>
                <Typography style={classes.p} >
                  <li>
                   On Tuesday June 7 we will have a poster session after the last talk in the lunch room of the mathematics department. Wine and cheese will be served! 
                   </li>
                </Typography>
                <br></br>
                <Typography style={classes.p} >
                  <li> There will be a conference dinner on Wednesday June 8. The event will take place during a boat trip to Drottningholm. The boat, the M/S Prins Carl Phillip, will depart at 18:00 from <Link href= "https://goo.gl/maps/f3d7MM4NZbCjiY5d7"> Klara Mälarstrand KM4</Link>  and return at 20:30. 
                  </li>
                </Typography>
                
                <br></br>
                <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell> </TableCell>
            <TableCell align="center">Monday</TableCell>
            <TableCell align="center">Tuesday</TableCell>
            <TableCell align="center">Wednesday</TableCell>
            <TableCell align="center">Thursday</TableCell>
            <TableCell align="center">Friday</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
    
              <TableCell align="center">{row.mon}</TableCell>
              <TableCell align="center">{row.tue}</TableCell>
              <TableCell align="center">{row.wed}</TableCell>
              <TableCell align="center">{row.thu}</TableCell>
              <TableCell align="center">{row.fri}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <Typography variant="h3" style={classes.h1}>
                   Monday
                </Typography>                
                <br></br>
                {this.state.list.map(item=> GenListItem(item))}
                <Typography variant="h3" style={classes.h1}>
                   Tuesday
                </Typography>                
                <br></br>
                {this.state.list2.map(item=> GenListItem(item))}
                <Typography variant="h3" style={classes.h1}>
                   Wednesday
                </Typography>                
                <br></br>
                {this.state.list3.map(item=> GenListItem(item))}
                <Typography variant="h3" style={classes.h1}>
                   Thursday
                </Typography>                
                <br></br>
                {this.state.list4.map(item=> GenListItem(item))}
                <Typography variant="h3" style={classes.h1}>
                   Friday
                </Typography>                
                <br></br>
                {this.state.list5.map(item=> GenListItem(item))}
              
            </div>
            )
        }
    }


export default Program;